module.exports = __webpack_public_path__ + "images/d52656ab987cb23e4007043134be88d5.jpg";